import { useFollowStatus, useFollowMutation } from '@/hooks/useFollows.js';

interface FollowButtonProps {
  issueKey: string;
}

export function FollowButton({ issueKey }: FollowButtonProps) {
  const { data, isLoading } = useFollowStatus(issueKey);
  const { follow, unfollow } = useFollowMutation(issueKey);

  const following = data?.following ?? false;
  const isPending = follow.isPending || unfollow.isPending;

  function handleClick() {
    if (following) {
      unfollow.mutate();
    } else {
      follow.mutate();
    }
  }

  if (isLoading) {
    return (
      <button disabled className="rounded-md border px-3 py-1.5 text-sm text-gray-400">
        ...
      </button>
    );
  }

  return (
    <button
      onClick={handleClick}
      disabled={isPending}
      className={`rounded-md border px-3 py-1.5 text-sm font-medium transition-colors ${
        following
          ? 'border-blue-200 bg-blue-50 text-blue-700 hover:bg-blue-100'
          : 'border-gray-300 text-gray-700 hover:bg-gray-50'
      } disabled:opacity-50`}
    >
      {following ? 'Following' : 'Follow'}
    </button>
  );
}
